<template>
  <div
    class="bg bg-static hidden-sm-and-down"
    style="
      height: 600px;
      width: 100vw;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    "
  >
    <v-row style="height: 600px" align="center" justify="space-around">
      <v-col cols="12" sm="6">
        <div class="ma-10 pl-16">
          <h1
            class="font-weight-black"
            style="overflow-wrap: break-word"
            v-text="`ナレッジをひとつに！`"
          ></h1>
          <div
            class="font-weight-bold mt-16 text-h5"
            style="overflow-wrap: break-word"
          >
            魅力あふれるナレッジが多いWebサイト。
          </div>
          <div
            class="font-weight-bold pt-2 text-h5"
            style="overflow-wrap: break-word"
          >
            あれもこれも伝えたいと思い、<br />チャットログでURLをたくさん送っていませんか？
          </div>
          <div
            class="font-weight-bold pt-2 text-h5"
            style="overflow-wrap: break-word"
          >
            vla.tipsでスマートに送りましょう！
          </div>
          <v-btn
            v-if="!isLogin"
            href="/login"
            class="mt-10 font-weight-bold"
            color="#5E00BC"
            dark
            x-large
            style="text-transform: none"
            ><v-icon>mdi-earth</v-icon>vla.tipsの世界へ</v-btn
          >
        </div>
      </v-col>
      <v-col cols="false" sm="6">
        <!--<v-img
                src="../../../assets/main.svg"
                max-height="100%"
                max-width="100%"
                ></v-img>-->
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "HomeHeader",
  computed: {
    isLogin: function () {
      return this.$store.getters["auth/isAuth"];
    },
  },
};
</script>

<style>
.bg-static {
  background-image: url("../../static/main.svg");
}
</style>
